import SideBar from '@/components/Sidebar';
import { Box, Stack, useTheme } from '@mui/material';
import Paper from '@/components/Paper';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import SeeMore from '@/components/SeeMore';
import { useRouter } from 'next/router';
import Badge from '../../Badge';
import HeaderBadgeComponent from '../../Badge/HeaderBadge';
import { socialMediaT, usefulLinksT } from '../types';
import getLocalFile from '@/utils/getLocalFile';

const ScamContentComponent = () => {
  const { matches } = useResponsive();
  const theme = useTheme();
  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');
  const content = getLocalFile(marketName, 'content');

  return (
    <Stack
      mt={{ xs: 6, lg: 21 }}
      mb={{ xs: 4, lg: 28.5 }}
      flexDirection={{ lg: 'row', md: 'column' }}
      gap={4}
    >
      <Stack sx={{ width: matches({ lg: '772.86076px', xs: '100%' }) }}>
        <Paper elevation={14} sx={{ p: 8, flex: 1 }}>
          <Stack>
            <HeaderBadgeComponent
              isScam={data.Information.isScam}
              endLogo={!data.Information.isScam}
              startLogo={data.Information.isScam}
              name_fa={data.Information.name_fa}
              name_en={data.Information.name_en}
              symbol={marketName || ''}
            />

            <Stack
              direction={matches({ lg: 'row' })}
              spacing={matches({ lg: 1, xs: 0 })}
              marginTop={3}
            >
              <Box sx={{ flexGrow: 1 }} />
              <Stack
                spacing={4}
                sx={{
                  width: matches({ lg: '100%' }),
                  background: theme.palette.secondary.A60,
                  p: matches({ lg: 6, xs: 3 }),

                  borderRadius: '12px'
                }}
              >
                <Stack direction="row" flexWrap="wrap" sx={{ gap: '7px' }}>
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    sx={{ gap: matches({ lg: '7px', xs: '4px' }) }}
                  >
                    <Typography
                      variant="body3"
                      weight="bold"
                      sx={{
                        mr: 3,
                        width: matches({ lg: 'auto', xs: '100%' })
                      }}
                    >
                      لینک‌های مفید:
                    </Typography>
                    {data?.cryptoInglance?.usefulLinks?.map(
                      (item: usefulLinksT, index: number) => (
                        <Badge
                          content={item.content}
                          image={item.image}
                          key={index}
                          link={item.link}
                        />
                      )
                    )}
                  </Stack>
                </Stack>

                <Stack direction="row" flexWrap="wrap" sx={{ gap: '7px' }}>
                  <Stack direction="row" flexWrap="wrap" sx={{ gap: '7px' }}>
                    <Typography
                      variant="body3"
                      weight="bold"
                      sx={{
                        mr: 3,
                        width: matches({ lg: 'auto', xs: '100%' })
                      }}
                    >
                      شبکه‌های اجتماعی:{' '}
                    </Typography>
                    {data?.cryptoInglance?.socialMedia.map(
                      (item: socialMediaT, index: number) => (
                        <Badge
                          image={item.image}
                          key={index}
                          link={item.link}
                        />
                      )
                    )}
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
          <Box sx={{ py: 9 }}>
            <Box sx={{ height: '100%' }}>
              <SeeMore
                height="20%"
                minHeight="706px"
                linearGradient="rgba(255, 255, 255, 0.00)"
                buttonProps={{
                  variant: 'contained',
                  fullWidth: matches({ xs: true, lg: false })
                }}
                fadeColor="#FFF"
                showMoreText="مشاهده بیشتر"
                showLessText="مشاهده کمتر"
              >
                <Stack
                  sx={{
                    '& p': {
                      color: theme.palette.textColor.A60,
                      fontSize: matches({ xs: '12px', lg: '14px' }),
                      pb: 3,
                      textAlign: 'start'
                    },
                    '& img': {
                      display: 'block',
                      margin: 'auto'
                    },
                    '& h4': {
                      fontSize: matches({ xs: '14px', lg: '16px' }),
                      color: theme.palette.textColor.A80,
                      pb: 2,
                      fontWeight: 600
                    },
                    '& h3': {
                      fontSize: matches({ xs: '14px', lg: '16px' }),
                      color: theme.palette.textColor.A80,
                      pb: 2,
                      fontWeight: 600
                    },
                    '& h2': {
                      fontSize: matches({ xs: '14px', lg: '16px' }),
                      color: theme.palette.textColor.A80,
                      pb: 2,
                      fontWeight: 600
                    },
                    '& h1': {
                      fontSize: matches({ xs: '14px', lg: '16px' }),
                      color: theme.palette.textColor.A80,
                      pb: 2,
                      fontWeight: 600
                    },
                    '& a': {
                      textDecoration: 'none',
                      color: theme.palette.primary.main
                    },
                    '& ol': {
                      color: theme.palette.textColor.A60,
                      fontSize: '14px',
                      textAlign: 'justify',
                      pl: matches({ xs: 4, lg: 14 }),
                      py: 5.5
                    }
                  }}
                  gap={4}
                >
                  <Box
                    component="div"
                    dangerouslySetInnerHTML={{
                      __html: content?.description || ''
                    }}
                  />
                </Stack>
              </SeeMore>{' '}
            </Box>
          </Box>
        </Paper>
      </Stack>
      <Stack sx={{ width: matches({ lg: '379.13924px', xs: '100%' }) }}>
        <SideBar />
      </Stack>
    </Stack>
  );
};

export default ScamContentComponent;
